import { Medal, Notebook, UserPlus } from "@phosphor-icons/react";

export const SectionOurNumber = () => {
  return (
    <section className="m-0 border-0 bg-[#F8F8F8] text-center">
      <div className="content-area pb-16 pt-8 md:pb-[2.5rem] md:pt-[2.5rem]">
        <h3 className="mb-32 text-center text-32 font-semibold uppercase leading-relaxed tracking-wide text-primaria-claro">
          nossos números
        </h3>
        <ul className="grid grid-cols-[17.5rem] items-center justify-center gap-8 sm:grid-cols-2 lg:grid-cols-3 lg:gap-0 lg:gap-x-2">
          <li className="rounded-lg bg-white p-8 shadow-[0px_6px_16px_rgba(0,0,0,0.05)] transition-all ease-linear hover:-translate-y-2">
            <span className="mb-6 grid h-12 w-12 place-content-center rounded-full border border-primaria-claro">
              <Medal size={20} className="text-black" />
            </span>
            <h3 className="heading-3 uppercase text-primaria-claro">top 1</h3>
            <span className="text-body-2">A maior promotora de Minas Gerais</span>
          </li>
          <li className="rounded-lg bg-white p-8 shadow-[0px_6px_16px_rgba(0,0,0,0.05)] transition-all ease-linear hover:-translate-y-2">
            <span className="mb-6 grid h-12 w-12 place-content-center rounded-full border border-primaria-claro">
              <UserPlus size={20} className="text-black" />
            </span>
            <h3 className="heading-3 uppercase text-primaria-claro">+20000</h3>
            <span className="text-body-2">Clientes atendidos por Mês</span>
          </li>
          <li className="rounded-lg bg-white p-8 shadow-[0px_6px_16px_rgba(0,0,0,0.05)] transition-all ease-linear hover:-translate-y-2">
            <span className="mb-6 grid h-12 w-12 place-content-center rounded-full border border-primaria-claro">
              <Notebook size={20} className="text-black" />
            </span>
            <h3 className="heading-3 uppercase text-primaria-claro">100%</h3>
            <span className="text-body-2">Atendimento Humanizado</span>
          </li>
        </ul>
      </div>
    </section>
  );
};
